var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-shell" }, [
      _c(
        "div",
        { ref: "imgRef", staticClass: "login-visual" },
        [
          _c("div", { staticClass: "visual-green-mask" }),
          _c(
            "el-carousel",
            {
              staticClass: "visual-carousel",
              attrs: { height: _vm.carouselHeight, trigger: "click" },
            },
            _vm._l(_vm.carouselArr, function (item) {
              return _c("el-carousel-item", { key: item.backgroundImage }, [
                _c("div", { staticClass: "carousel-img", style: item }),
              ])
            }),
            1
          ),
          _c("div", { staticClass: "visual-copy" }, [
            _c("span", { staticClass: "visual-badge" }, [
              _vm._v("ANJUN EXPRESS"),
            ]),
            _c("p", { staticClass: "visual-kicker" }, [
              _vm._v("SMART LOGISTICS WORKSPACE"),
            ]),
            _c("h1", { staticClass: "visual-title" }, [
              _vm._v(_vm._s(_vm.$t("login.anjunKD"))),
            ]),
            _c("p", { staticClass: "visual-desc" }, [
              _vm._v(_vm._s(_vm.$t("login.WELCOME"))),
            ]),
            _vm._m(0),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "login-panel" }, [
        _c("div", { staticClass: "login-box" }, [
          _c(
            "div",
            { staticClass: "login-toolbar" },
            [
              _c("span", { staticClass: "login-toolbar__label" }, [
                _vm._v("Language"),
              ]),
              _c("lang-select", { staticClass: "login-language-select" }),
            ],
            1
          ),
          _c("div", { staticClass: "login-brand" }, [
            _c("span", { staticClass: "brand-mark" }),
            _c("span", { staticClass: "brand-name" }, [
              _vm._v(_vm._s(_vm.$t("login.anjunKD"))),
            ]),
          ]),
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "title-main" }, [
              _vm._v(_vm._s(_vm.$t("login.WELCOME"))),
            ]),
            _c("p", { staticClass: "title-sub" }, [
              _vm._v(_vm._s(_vm.$t("login.platformSubtitle"))),
            ]),
          ]),
          _c("div", { staticClass: "inp_box" }, [
            _c("div", { staticClass: "field" }, [
              _c("span", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("login.inputNumber"))),
              ]),
              _c("div", { staticClass: "field-control" }, [
                _c("i", { staticClass: "el-icon-user" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.loginForm.username,
                      expression: "loginForm.username",
                      modifiers: { trim: true },
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("login.inputNumber"),
                    autofocus: "",
                    max: "20",
                    min: "3",
                    type: "text",
                  },
                  domProps: { value: _vm.loginForm.username },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleLogin($event)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.loginForm,
                        "username",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field field-password" }, [
              _c("span", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("login.passwordPrompt"))),
              ]),
              _c("div", { staticClass: "field-control" }, [
                _c("i", { staticClass: "el-icon-lock" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.loginForm.password,
                      expression: "loginForm.password",
                      modifiers: { trim: true },
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("login.passwordPrompt"),
                    max: "20",
                    min: "3",
                    type: _vm.passwordType,
                  },
                  domProps: { value: _vm.loginForm.password },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleLogin($event)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.loginForm,
                        "password",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _c(
                  "button",
                  {
                    staticClass: "password-visibility-toggle",
                    attrs: {
                      "aria-label":
                        _vm.passwordType === "password"
                          ? "显示密码"
                          : "隐藏密码",
                      type: "button",
                    },
                    on: { click: _vm.togglePasswordVisible },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-view",
                      class: {
                        "is-password-hidden": _vm.passwordType === "password",
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
          _c("div", {
            staticClass: "recaptcha-container",
            attrs: { id: "recaptcha-container" },
          }),
          _c("div", { staticClass: "but" }, [
            _c(
              "button",
              { attrs: { type: "button" }, on: { click: _vm.handleLogin } },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("login.login")))]),
                _c("i", { staticClass: "el-icon-right" }),
              ]
            ),
          ]),
          _c("div", { staticClass: "login-divider" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("login.enterpriseLoginDivider"))),
            ]),
          ]),
          _c("div", { staticClass: "feishu-login" }, [
            _c(
              "div",
              {
                staticClass: "feishu-login-content",
                on: { click: _vm.handleFeishuLogin },
              },
              [
                _c("img", {
                  staticClass: "feishu-login-icon",
                  attrs: {
                    alt: "飞书登录",
                    src: "/static/logo/feishu-logo.png",
                  },
                }),
                _c("span", { staticClass: "feishu-login-text" }, [
                  _vm._v(_vm._s(_vm.$t("login.feishuLogin"))),
                ]),
                _c("i", { staticClass: "el-icon-right feishu-login-arrow" }),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "visual-metrics" }, [
      _c("div", { staticClass: "metric-card" }, [
        _c("span", { staticClass: "metric-label" }, [_vm._v("Routes")]),
        _c("strong", [_vm._v("Global Delivery")]),
      ]),
      _c("div", { staticClass: "metric-card" }, [
        _c("span", { staticClass: "metric-label" }, [_vm._v("Tracking")]),
        _c("strong", [_vm._v("Realtime Visibility")]),
      ]),
      _c("div", { staticClass: "metric-card" }, [
        _c("span", { staticClass: "metric-label" }, [_vm._v("Network")]),
        _c("strong", [_vm._v("Warehouse Matrix")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }